export const FOLDERS_ICON = 'folders';
export const NAMESPACE_ICON = 'name-space';
export const ANALYTICS_ICON = 'analytics';
export const DIAGRAM_ICON = 'diagram';
